/**
 * BREND SƏHİFƏSİ - JavaScript
 * Alfabe filterləri və brendlərin sıralanması
 */

class BrandsPage {
  constructor() {
    this.alphabetBtns = document.querySelectorAll('.brands-alphabet__btn');
    this.brandSections = document.querySelectorAll('.brands-section');
    this.brandItems = document.querySelectorAll('.brand-item');
    this.container = document.querySelector('.brands-container');
    
    this.init();
  }
  
  init() {
    // Alfabe düymələrinə event listener əlavə et
    this.alphabetBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleAlphabetClick(e));
    });
    
    // Mövcud brendlərə əsasən düymələri aktiv/deaktiv et
    this.updateAlphabetButtons();
    
    // Səhifə yüklənəndə URL-də hash varsa, həmin hərf üzrə filter et
    this.checkUrlHash();
  }
  
  /**
   * Alfabe düyməsinə klik
   */
  handleAlphabetClick(e) {
    const btn = e.currentTarget;
    const letter = btn.dataset.letter;
    
    // Aktiv düyməni dəyiş
    this.alphabetBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    
    // Filter et
    if (letter === 'all') {
      this.showAllBrands();
    } else {
      this.filterByLetter(letter);
    }
    
    // URL hash-ı yenilə
    if (letter !== 'all') {
      window.history.pushState(null, '', `#${letter}`);
    } else {
      window.history.pushState(null, '', window.location.pathname);
    }
  }
  
  /**
   * Bütün brendləri göstər
   */
  showAllBrands() {
    this.brandSections.forEach(section => {
      section.classList.remove('hidden');
    });
    
    // Boşluq mesajını gizlət
    this.hideNoResults();
  }
  
  /**
   * Hərfə görə filter et
   */
  filterByLetter(letter) {
    let hasVisibleBrands = false;
    
    this.brandSections.forEach(section => {
      const sectionLetter = section.dataset.letter;
      
      if (sectionLetter === letter) {
        section.classList.remove('hidden');
        hasVisibleBrands = true;
        
        // Həmin bölməyə scroll et
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      } else {
        section.classList.add('hidden');
      }
    });
    
    // Heç brend yoxdursa, mesaj göstər
    if (!hasVisibleBrands) {
      this.showNoResults(letter);
    } else {
      this.hideNoResults();
    }
  }
  
  /**
   * Mövcud brendlərə əsasən alfabe düymələrini yenilə
   */
  updateAlphabetButtons() {
    const availableLetters = new Set();
    
    this.brandSections.forEach(section => {
      const letter = section.dataset.letter;
      if (letter) {
        availableLetters.add(letter);
      }
    });
    
    this.alphabetBtns.forEach(btn => {
      const letter = btn.dataset.letter;
      
      // "Hamısı" düyməsi həmişə aktiv
      if (letter === 'all') return;
      
      // Hərf mövcuddursa, aktiv et
      if (!availableLetters.has(letter)) {
        btn.classList.add('disabled');
      } else {
        btn.classList.remove('disabled');
      }
    });
  }
  
  /**
   * URL hash-ı yoxla və filter et
   */
  checkUrlHash() {
    const hash = window.location.hash.replace('#', '');
    
    if (hash && hash !== 'all') {
      // Hərf düyməsini tap və klikə
      const btn = Array.from(this.alphabetBtns).find(
        b => b.dataset.letter === hash
      );
      
      if (btn && !btn.classList.contains('disabled')) {
        btn.click();
      }
    }
  }
  
  /**
   * "Nəticə tapılmadı" mesajı göstər
   */
  showNoResults(letter) {
    // Əvvəlki mesajı sil
    this.hideNoResults();
    
    const noResults = document.createElement('div');
    noResults.className = 'brands-no-results';
    noResults.innerHTML = `
      <p><strong>${letter}</strong> hərfi ilə başlayan brend tapılmadı</p>
      <button onclick="document.querySelector('[data-letter=all]').click()">
        Bütün brendlərə bax
      </button>
    `;
    
    this.container.appendChild(noResults);
  }
  
  /**
   * "Nəticə tapılmadı" mesajını gizlət
   */
  hideNoResults() {
    const existing = this.container.querySelector('.brands-no-results');
    if (existing) {
      existing.remove();
    }
  }
}

// Səhifə yüklənəndə işə sal
document.addEventListener('DOMContentLoaded', () => {
  new BrandsPage();
});

